<ul>
  <li *ngFor="let item of list; index as i" [ngClass]="{ 'with-childs': item.children && item.children.length }">
    <div class="filter-content-wrapper">
      <span>{{ item.name }}</span>
      <div class="action-btns">
        <button class="btn-action-icon edit-btns" [ngClass]="{ active: item.id === activeId }" (click)="editItem(item)">
          <i id="edit"></i>
        </button>
        <div class="buttons-order">
          <button *ngIf="!activeId" [disabled]="i === 0" (click)="moveItem(i, 'up', item.id)">
            <i class="fa fa-angle-up"></i>
          </button>
          <button *ngIf="!activeId" [disabled]="i === list.length - 1" (click)="moveItem(i, 'down', item.id)">
            <i class="fa fa-angle-down"></i>
          </button>
        </div>
      </div>
    </div>
    <div *ngIf="item.children && item.children.length" class="filter-children-content-wrapper">
      <app-filter-previewitem
        [activeId]="activeId"
        [list]="item.children"
        (updatedPositionItem)="moveItemFromChild($event)"
        (editedItem)="editItem($event)"></app-filter-previewitem>
    </div>
  </li>
</ul>
